export default "__VITE_ASSET__DAInc$wM__"